module.exports = __webpack_public_path__ + "img/2026-03-24c_4.16a07808.jpg";